import { render, staticRenderFns } from "./message-attachments.vue?vue&type=template&id=4336706e&"
import script from "./message-attachments.vue?vue&type=script&lang=js&"
export * from "./message-attachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports